import script from "./groupItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./groupItem.vue?vue&type=script&setup=true&lang=ts"

import "./groupItem.vue?vue&type=style&index=0&id=9a70a8cc&lang=less&scoped=true"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9a70a8cc"]])

export default __exports__